import Vue from 'vue';
import App from './main.vue';
import VueRouter from 'vue-router';
import routes from './routes';
import './validation/vee-validate.js';
import NavigationGuards from "./components/NavigationGuards/NavigationGuards";

import globalDirectives from './directives/globalDirectives';
Vue.use(globalDirectives);

import globalComponents from './components/globalComponents';
Vue.use(globalComponents);

Vue.use(NavigationGuards);

//---------------------------------------------------------------------------------------------------------------------/
// Vuex
//---------------------------------------------------------------------------------------------------------------------/
import store from './store/store.js';

//---------------------------------------------------------------------------------------------------------------------/
// Axios
//---------------------------------------------------------------------------------------------------------------------/
import axios from 'axios';

//axios.defaults.baseURL = 'http://localhost:8000/api/'
axios.defaults.baseURL = '/api/'

// Add a request interceptor
axios.interceptors.request.use(function (config) {

    /* VIERIFAÇAO DE baseURL PARA EVITAR DE ENVIAR O TOKEN PARA A CONSULTA DE CEP*/
    if (config.baseURL === 'viacep.com.br') {
        return config;
    }

    store.commit('loadingScreen/toggleLoading');

    let token = store.getters['auth/isAuthenticated'];

    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
});

// Add a response interceptor
axios.interceptors.response.use(function (response) {
    store.commit('loadingScreen/toggleLoading');
    return response;
}, function (error) {
    store.commit('loadingScreen/toggleLoading');
    return Promise.reject(error);
});

Vue.prototype.axios = axios;

//---------------------------------------------------------------------------------------------------------------------/
// SweetAlert
//---------------------------------------------------------------------------------------------------------------------/
import VueSweetalert2 from 'vue-sweetalert2';

Vue.use(VueSweetalert2);

//**Vue Carousel */

import VueCarousel from 'vue-carousel';
Vue.use(VueCarousel);

//---------------------------------------------------------------------------------------------------------------------/
// Vue Router
//---------------------------------------------------------------------------------------------------------------------/
Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior(to, from, savedPosition) {
        return {x: 0, y: 0}
    }
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.forVisitors)) {
        if (store.getters['auth/isAuthenticated']) {
            next({
                path: '/painel-administrativo'
            });
        } else next();

    } else if (to.matched.some(record => record.meta.forAuth)) {

        if (!store.getters['auth/isAuthenticated']) {
            next({
                path: '/sistema',
            });
        } else next();

    } else next();
});

//---------------------------------------------------------------------------------------------------------------------/
// Vue
//---------------------------------------------------------------------------------------------------------------------/
new Vue({
    el: '#app',
    template: '<app/>',
    router,
    store,
    components: {App},
});
